


























































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SummaryOverview extends Vue {
  @Prop() readonly doc!: any;
}
